import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-16" }, "Getting Help", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Example Scenes", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "explaining how and why", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Community", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Currently the best place to get help is on the public channels:", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://polygonjs.com/discord"
    }, "Discord")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://forum.polygonjs.com"
    }, "Our Forum")
  ])
], -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Private Consulting", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" We also offer help on private channels (emails, video calls, tutorials) as well as consulting on specific projects. "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:gui@polygonjs.com" }, "Email us"),
  /*#__PURE__*/_createTextVNode(" to know more. ")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("p", null, [
      _createTextVNode(" The best place to start is the growing "),
      _createVNode(_component_router_link, {
        to: _ctx.docsRoute(_ctx.DocsRoute.EXAMPLES)
      }, {
        default: _withCtx(() => [
          _createTextVNode("list of examples")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createTextVNode(". They cover many different subjects, and you'll see comments under most nodes, "),
      _hoisted_3,
      _createTextVNode(" a set up is made. With those, you can quickly become familiar with how Polygonjs works and how it could help you. ")
    ]),
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8
  ], 64 /* STABLE_FRAGMENT */))
}